import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { RTL } from 'src/app/@theme/const';
import { Subject, takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TabConst } from 'src/app/tabms/tab-consts';
import { FieldDicHelperService } from 'src/app/tabms/services/global/field-dic-helper.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-form-multiselect',
  templateUrl: './form-multiselect.component.html',
  styleUrl: './form-multiselect.component.scss'
})
export class FormMultiselectComponent implements OnInit, OnDestroy {

  @Input() control: FormControl = new FormControl();
  @Input() fieldName: string = '';
  @Input() options: any[] = [];
  @Input() optionLabel: string = 'name';
  @Input() optionValue: string = 'value';
  @Input() type: string = ''
  placeholder?: string
  @Input() size: 'default' | 'compact' | 'xs' = TabConst.DEFAULTSIZE;
  @Input() showClear: boolean = false;
  @Input() display: 'comma' | 'chip' = 'chip';
  @Input() customClass: string = '';
  @Input() disabled: boolean = false;
  @Input() maxSelectedLabels: number = 999; // Show all selected items by default
  @Output() selectionChange = new EventEmitter<any>();
  currentLang: string = 'en';
  computedPlaceholder: string = '';
  private destroy$: Subject<void> = new Subject<void>();
  @Input() validate: boolean = true //to apply validation only if form not criteria
    defaultValue = null
  systemMenuId
  constructor(
    private baseService: BaseService,
    private themeLayoutService: ThemeLayoutService,
    private translate: TranslateService,
      private fieldDicHelperService: FieldDicHelperService,
        private activateRoute: ActivatedRoute,
  ) {
     this.activateRoute.params.pipe(takeUntil(this.destroy$)).subscribe({
      next: (params) => {
        this.systemMenuId = params['id']
      }
    })
    this.currentLang = this.baseService.getCurrentLanguage();

    // Listen for direction/language changes
    this.themeLayoutService.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir) => {
        this.currentLang = (dir === RTL) ? 'ar' : 'en';
       this.loadFieldData();
      }
    });

  }

  ngOnInit(): void {
    this.loadFieldData();
       this.baseService.createFormDisplay
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res?.show && res?.id === null) {
            this.loadFieldData(); // create only
          }
        },
      });
  }
  private loadFieldData() {
   //debugger
    this.fieldDicHelperService
      .getFieldData(this.fieldName, this.systemMenuId, this.validate, this.control, this.currentLang)
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ placeholder, defaultValue, type, disabled }) => {
        this.placeholder = placeholder;
        if (disabled) {
          this.control?.disable({ emitEvent: false });
        }
      });
  }

  private updatePlaceholder(): void {
    // Simple fallback placeholder logic
    if (this.placeholder) {
      this.computedPlaceholder = this.placeholder;
    } else {
      this.computedPlaceholder = this.translate.instant('select') + ' ' + this.translate.instant(this.fieldName);
    }
  }

  onSelectionChange(event: any): void {
    this.selectionChange.emit(event);
  }

  // Explicit clear handler for p-multiSelect showClear button
  onClear(): void {
    const empty: any[] = [];
    this.control?.setValue(empty, { emitEvent: true });
    this.control?.markAsDirty();
    this.control?.markAsTouched();
    this.control?.updateValueAndValidity();

    this.selectionChange.emit({ value: empty });
  }


  get containerClasses(): string {
    let classes = 'w-100 m-t-5';

    if (this.size === 'compact') {
      classes += ' multiselect-compact';
    } else if (this.size === 'xs') {
      classes += ' multiselect-xs';
    }

    if (this.customClass) {
      classes += ` ${this.customClass}`;
    }

    return classes;
  }
    ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
